<template>
  <div class="companies-page">
    <div class="companies-page_container">
      <div class="header">
        <span>我监控的公司</span>
        <div>
          <search-add-monitor-input class="search-add-monitor-input" @selectCompany="emitSelectCompany"></search-add-monitor-input>
          <batch-add-monitor class="batch-add-monitor" @change="addSuccess"></batch-add-monitor>
        </div>
      </div>
      <monitor-list :tableData="tableData" :selectedCompany="selectedCompany"></monitor-list>
    </div>
  </div>
</template>

<script>
import MonitorList from '@/components/news-monitor/MonitorList';
import BatchAddMonitor from '@/components/news-monitor/BatchAddMonitor';
import SearchAddMonitorInput from '@/components/news-monitor/SearchAddMonitorInput';

export default {
  data() {
    return {
      selectedCompany: '',
      tableData: []
    };
  },
  methods: {
    emitSelectCompany(res) {
      this.selectedCompany = res;
    },
    addSuccess(res) {
      this.tableData = res;
    }
  },
  components: {
    MonitorList,
    BatchAddMonitor,
    SearchAddMonitorInput
  }
};
</script>

<style lang="scss" scoped>
.companies-page{
  width: 100%;
  min-height: 100%;
  background: #333138;
  &_container{
    width: 1048px;
    margin: 0 auto;
    padding:24px;
    .header{
      display: flex;
      justify-content: space-between;
      margin-bottom:20px;
      color:#ffffff;
      font-size:24px;
      font-family: 'DIN-Bold' sans-serif;
      .search-add-monitor-input {
        display: inline-block;
      }
      .batch-add-monitor {
        display: inline-block;
        margin-left: 16px;
      }
    }
  }
}
</style>



